export default "__VITE_ASSET__11c059be__"